var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "navbar-default sidebar", attrs: { role: "navigation" } },
    [
      _c("div", { staticClass: "sidebar-nav" }, [
        _c("div", { attrs: { id: "sidebar-nav-inner" } }, [
          _c("ul", { staticClass: "nav", attrs: { id: "side-menu" } }, [
            _c(
              "li",
              [
                _c(
                  "router-link",
                  {
                    staticClass: "tests_menu_namespaces_action",
                    attrs: { tags: "a", to: "/namespaces" }
                  },
                  [
                    _c("i", { staticClass: "fa fa-coins fa-fw" }),
                    _vm._v(" "),
                    _c("span", { staticClass: "narrow-hide" }, [
                      _vm._v("Namespaces")
                    ])
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              [
                _c(
                  "router-link",
                  {
                    staticClass: "tests_menu_tokens_action",
                    attrs: { tags: "a", to: "/tokens" }
                  },
                  [
                    _c("i", { staticClass: "fa fa-key fa-fw" }),
                    _vm._v(" "),
                    _c("span", { staticClass: "narrow-hide" }, [
                      _vm._v("Tokens")
                    ])
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              [
                _c(
                  "router-link",
                  {
                    staticClass: "tests_menu_quotas_action",
                    attrs: { tags: "a", to: "/quotas" }
                  },
                  [
                    _c("i", { staticClass: "fa fa-tachometer-alt fa-fw" }),
                    _vm._v(" "),
                    _c("span", { staticClass: "narrow-hide" }, [
                      _vm._v("Quotas")
                    ])
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _vm.superadmin
              ? _c(
                  "li",
                  [
                    _c(
                      "router-link",
                      {
                        staticClass: "tests_menu_tokens_action",
                        attrs: { tags: "a", to: "/users" }
                      },
                      [
                        _c("i", { staticClass: "fa fa-user fa-fw" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "narrow-hide" }, [
                          _vm._v("Users")
                        ])
                      ]
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.superadmin
              ? _c(
                  "li",
                  [
                    _c(
                      "router-link",
                      {
                        staticClass: "tests_menu_tokens_action",
                        attrs: { tags: "a", to: "/health" }
                      },
                      [
                        _c("i", { staticClass: "fa fa-heartbeat fa-fw" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "narrow-hide" }, [
                          _vm._v("Health")
                        ])
                      ]
                    )
                  ],
                  1
                )
              : _vm._e()
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-504467c3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-504467c3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Menu.vue
// module id = null
// module chunks = 